import Splide from '@splidejs/splide';

export default class CategoriesSlider {
    constructor() {
        this.categoriesSliders = [
            ...document.querySelectorAll('.jsBlogCategoriesSlider'),
        ];

        this.events();
    }

    events() {
        if (this.categoriesSliders.length) {
            this.categoriesSliders.forEach((coursesSlider) =>
                this.initializeCoursesSlider(coursesSlider),
            );
        }
    }

    initializeCoursesSlider(categoriesSliders) {
        // eslint-disable-next-line no-unused-vars
        this.activeSlider = new Splide(categoriesSliders, {
            type: 'slide',
            perPage: 9,
            pagination: false,
            gap: '0.625rem',
            breakpoints: {
                1024: {
                    arrows: false,
                },
                767: {
                    destroy: false,
                    perPage: 10,
                },
                575: {
                    perPage: 3,
                },
            },
        }).mount();
    }
}
